import {DriverContactFormVehicleModelEnum} from '@/services/api-clients';


export function driverContactFormVehicleModelImageFilter(model: DriverContactFormVehicleModelEnum): string {
  switch(model) {
    case DriverContactFormVehicleModelEnum.ToyotaCorolla2018: return 'toyota_corolla_2018';
      case DriverContactFormVehicleModelEnum.ToyotaYarisCross2023: return 'toyota_yaris_cross_2023';
      case DriverContactFormVehicleModelEnum.ToyotaYaris2022: return 'toyota_yaris_2022';
      case DriverContactFormVehicleModelEnum.SkodaFabia2018: return 'skoda_fabia_2018';
      case DriverContactFormVehicleModelEnum.DaciaLodgy2016: return 'dacia_lodgy_2016';
      case DriverContactFormVehicleModelEnum.FordFocus2018: return 'ford_focus_2018';
      case DriverContactFormVehicleModelEnum.KiaRio2018: return 'kia_rio_2018';
      case DriverContactFormVehicleModelEnum.ToyotaAygo2021: return 'toyota_aygo_2021';
    case DriverContactFormVehicleModelEnum.ToyotaCHR: return 'toyota_c_hr';
    default: return '';
  }
}
